
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { EditCourseSidebar } from "./EditCourseSidebar";
import CoreDetails from "./CoreDetails";
import CourseLevels from "./CourseLevels";
import CourseUsers from "./CourseUsers";
import ContentStatus from "./ContentStatus";
import { BackLink, Button, CancelButton, PageTitle, PageHeader } from "../../../components/StyledElements";
import { getCourseInfo } from "../../../services/courses"
import Loading from "../../../components/Loading";
import { AppContext } from "../../../contexts/AppContext";
import { useAuthContext } from "../../../contexts/AuthContext";
import swal from "sweetalert2";

import { useCourseContext } from "../../../contexts/CoursesContext";

export const EditCourse = () => {
  console.log("!!! RENDERING EditCourse COMPONENT");
  const { activeUser } = useAuthContext();
  const { selectedClient } = useContext(AppContext);
  const navigate = useNavigate();
  const { course_id } = useParams();
  const [showSidebar, setShowSidebar] = useState(true);
  const [selectedTab, setSelectedTab] = useState(window.location.hash ? window.location.hash.substr(1) : "details");

  const { selectedCourse, setSelectedCourse, setUpdatedCourse, updatedCourse, canSaveCourse, saveUpdatedCourse } = useCourseContext();
  const [savingCourse, setSavingCourse] = useState(false);


  console.log("!!! course ID: ", course_id);

  useEffect(() => {
    // Fetch live event details using course_id
    const fetchCourse = async () => {
      const results = await getCourseInfo(course_id, selectedClient);
      console.log("!!! course RESULTS: ", results);
      if (results.success) {
        const course = results.course;
        setUpdatedCourse(course);
        setSelectedCourse(course);
      } else {
        swal.fire({
          title: "Error",
          text: results.message || "Failed to fetch course details.",
          icon: "error",
        }).then(() => {
          navigate(`/courses/`);
        });
      }
    };
    if (course_id && course_id !== "create") {
      fetchCourse();
    } else {
      const newCourse = {
        public_id: "",
        name: "",
        description: "",
        client_id: activeUser?.client_id || null,
      };
      setUpdatedCourse(newCourse);
      setSelectedCourse(newCourse);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course_id]);

  const saveCourse = async () => {
    if (!canSaveCourse() || savingCourse) {
      return;
    }
    setSavingCourse(true);
    const public_id = await saveUpdatedCourse();
    console.log("!!! PUBLIC ID AFTER SAVE: ", public_id);
    if (public_id) {
      // Update url if it's a new event
      window.history.replaceState(null, null, `/course/${public_id}`);
      swal.fire({
        title: "Success",
        text: "Course saved successfully.",
        icon: "success",
      });
    }
    setSavingCourse(false);
  }

  if (!updatedCourse && course_id) {
    return <Loading>Loading Course...</Loading>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)", height: "100%" }}>
      <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)" }}>

        <EditCourseSidebar
          show={showSidebar}
          defaultSelectedTab={selectedTab}
          onNavItemClicked={(navItem) => {
            setSelectedTab(navItem);
          }}
          onToggle={() => {
            setShowSidebar(!showSidebar);
          }}
        />
      </div>
      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          width: `calc(100% - ${showSidebar ? "250px" : "0px"})`,
          minHeight: "calc(100vh - 40px)",
          position: "relative",
          backgroundColor: "var(--content-item-bg)",
          padding: "20px",
          borderRadius: "8px",
          color: "var(--main-font-color)",
          zIndex: 1,
          /*height: "2000px",*/
        }}
      >
        <PageHeader style={{ position: "sticky", top: "0px", backgroundColor: "var(--content-item-bg)", zIndex: 2, display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
          <div>
            <BackLink onClick={() => {
              navigate(`/courses`);
            }} >
              <i className="fa fa-arrow-left" /> Back to Courses</BackLink>
            <PageTitle title={`${updatedCourse?.id ? "Edit" : "New"} Course`} style={{ marginBottom: "0px" }} />
            {updatedCourse?.title ?
              <PageTitle title={updatedCourse?.title} style={{ marginBottom: "10px", fontWeight: "500", fontSize: "20px" }} />
              : null}
          </div>
          {selectedTab !== "chat-sessions" ? (
            <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
              <CancelButton onClick={() => {
                setUpdatedCourse(selectedCourse);
              }}>Cancel</CancelButton>
              <Button disabled={!canSaveCourse() || savingCourse} onClick={saveCourse} style={{ marginLeft: "auto" }}>{savingCourse ? "Saving Changes" : "Save Changes"}</Button>
            </div>
          ) : (
            null
          )}
        </PageHeader>
        <div style={{ backgroundColor: "var(--content-item-bg)", marginTop: "20px", marginBottom: "40px", height: "calc(100% - 80px)" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", height: "100%" }}>
            <div style={{ width: "100%", height: "100%" }}>
              <CoreDetails
                style={{ display: selectedTab === "details" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <CourseUsers
                style={{ display: selectedTab === "users" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <CourseLevels
                style={{ display: selectedTab === "levels" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <ContentStatus
                style={{ display: selectedTab === "review" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditCourse;

